import QuestionRichText from './QuestionRichText';
import StylingTextQuestionToRTEProps from '../../styling/hocs/StylingToRTEProps/StylingTextQuestionToRTEProps';

export default StylingTextQuestionToRTEProps(QuestionRichText);
